export const FORM_ERROR_MESSAGES = {
    required: "Este campo es requerido",
    number: "Debe ser un número",
    text: "Debe ser un texto",
    date: "Debe tener un formato de fecha válido",
};

export const REQUEST_MESSAGES = {
    UPDATE_SUCCESS: "Edición exitosa",
    INSERT_SUCCESS: "Creación exitosa",
    DELETE_SUCCESS: "Borrado exitosa",
    DEFAULT: "Proceso exitoso",
};
